module.exports = __webpack_public_path__ + "static/img/10.b325871.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/10.png
// module id = K+fq
// module chunks = 0